/**
 * Created by andrey on 21.12.2020.
 */

Unit.CreateHierarchyMenu = function (callback) {
    const menu = {};

    Object.keys(Merge2.current.families || {}).forEach((code) => {
        if (["unknown", "multiCellBody", "specialoffer"].indexOf(code) !== -1) {
            return;
        }

        const type = Families[code].type || "other";
        const units = {};

        for (let stage = 0; stage < Families[code].units.length; ++stage) {
            const unit = { code, stage };

            units[Unit.GetKey(unit)] = {
                icon: UnitView.getUnitImage.bind(UnitView, unit),
                action: callback.bind(null, unit)
            };
        }

        if (!menu[type]) {
            menu[type] = {};
        }

        menu[type][code] = units;
    });
    return menu;
};

cleverapps.override(cleverapps.Tool, {
    minigame: ToolFolder.create(() => {
        const mineGameSceneComponent = ComponentMap.getByName(cleverapps.Scenes.GetRunningScene(), "MineGameSceneComponent");
        const minigame = mineGameSceneComponent && mineGameSceneComponent.mineGame;
        if (minigame) {
            return {
                win: minigame.win.bind(minigame)
            };
        }
    }),

    game: {
        win: undefined,
        lose: undefined,

        stop_saving: function () {
            connector.dataLoader.setEnabled(false);
            cleverapps.dataLoader.setEnabled(false);
        },

        energyBooster: function () {
            cleverapps.focusManager.display({
                focus: "EnergyBoosterTool",
                action: function (f) {
                    new RewardWindow({ energyBooster: "15 minutes" }, { event: cleverapps.EVENTS.EARN.OTHER });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        },

        tutorial: ToolFolder.create(() => {
            const menu = {};

            menu.finishAll = function () {
                Merge2.current.tutorial.finishAll();
                cleverapps.tutorial.stop();

                Merge2.current.quests.quests = Merge2.current.quests.quests.filter((quest) => !quest.getTutorial());
                Merge2.current.quests.save();
            };

            if (typeof MergeTutorials !== "undefined") {
                for (const id in MergeTutorials) {
                    menu[id] = function (id) {
                        cleverapps.focusManager.display({
                            focus: "quests",
                            action: function (f) {
                                Merge2.current.tutorial.showTutorial(MergeTutorials[id], f);
                            }
                        });
                    }.bind(null, id);
                }
            }

            return menu;
        }),

        toggleAnchorsMode: {
            flag: "keyboardAnchorsMode"
        },

        toggleNodeDebugPanel: {
            flag: "nodeDebugPanelMode"
        },

        hideUI: function () {
            cleverapps.gameModes.noSidebar = true;
            Merge2SceneComponent.prototype.hasExtraBar = function () {
                return false;
            };
            cleverapps.gameModes.noUpMenu = true;

            cleverapps.Tool.Debug.screenshots();
        },

        makeUnknown: ToolFolder.create(() => {
            const menu = {};

            menu.clear = function () {
                cleverapps.dataLoader.remove(DataLoader.TYPES.UNKNOWN_UNIT_TEST);
                cleverapps.dataLoader.processSaveQueue();
                setTimeout(window.location.reload.bind(window.location), 0);
            };

            Object.keys(cleverapps.meta.getSelectedLocation().families || {}).forEach((code) => {
                menu[code] = {
                    family: function () {
                        cleverapps.dataLoader.save(DataLoader.TYPES.UNKNOWN_UNIT_TEST, {
                            code
                        });
                        cleverapps.dataLoader.processSaveQueue();
                        setTimeout(window.location.reload.bind(window.location), 0);
                    },
                    lastUnit: function () {
                        cleverapps.dataLoader.save(DataLoader.TYPES.UNKNOWN_UNIT_TEST, {
                            code,
                            stage: Families[code].units.length - 1
                        });
                        cleverapps.dataLoader.processSaveQueue();
                        setTimeout(window.location.reload.bind(window.location), 0);
                    }
                };
            });
            return menu;
        }),

        testUnitSaveLogs: function () {
            const slot = Map2d.currentMap.findEmptySlot(0, 0);

            const unit = new Unit({ code: "wood", stage: 3 });
            unit.setPosition(slot.x, slot.y);

            cleverapps.notification.create(`unit created ${unit.code}_${unit.stage}. It will be saved in 15 sec.`);

            setTimeout(() => {
                unit.save();
                cleverapps.notification.create(`unit saved ${unit.code}_${unit.stage}`);
            }, 15 * 1000);
        },

        nextLucky: function () {
            Merge2Generator.debugNextLucky = !Merge2Generator.debugNextLucky; 

            const game = cleverapps.Tool.game;
            const handler = game.nextLucky || game[`${ToolMenuItem.ACTIVE_ITEM}nextLucky`];
            delete game.nextLucky;
            delete game[`${ToolMenuItem.ACTIVE_ITEM}nextLucky`];

            const key = `${Merge2Generator.debugNextLucky ? ToolMenuItem.ACTIVE_ITEM : ""}nextLucky`;
            game[key] = handler;

            cleverapps.toolModel.refresh();
        },

        addUnitToStorage: function () {
            const backpack = Merge2.current.backpack;

            const index = backpack.findFreeSlot();
            const unit = {
                stage: 0,
                code: "a"
            };

            unit.getType = () => "resource";
            unit.getInfo = () => ({ code: unit.code, stage: unit.stage });

            const currentWindow = cleverapps.focusManager.currentWindow();
            const storageView = currentWindow && currentWindow.backpackView;

            if (!backpack.isFull() && backpack.canAcceptUnit(unit)) {
                backpack.insert(index, unit);

                if (storageView) {
                    storageView.addToSlot(unit, index);
                }
            }
        },

        merge2orders: ToolFolder.create(() => ({
            setOrderIndex: function () {
                displayToolPrompt((amount) => {
                    amount = parseInt(amount);
                    if (!isNaN(amount)) {
                        Merge2.current.orderManager.setOrderIndex(amount);
                    }
                }, "Enter amount", 10);
            },

            showCurrentOrderIndex: function () {
                cleverapps.notification.create(Merge2.current.orderManager.index, {
                    debugInfo: true
                });
            }
        }))
    },

    Debug: {
        offers: ToolFolder.create(() => {
            const res = {};

            const keyToNameMap = Object.fromEntries(Object.entries(Offers.TYPES).map(([k, v]) => [v, k]));

            Object.entries(cleverapps.offerManager.offers).forEach(([key, offer]) => {
                res[`${keyToNameMap[key]}  ${cleverapps.intervalToString(offer.logic.getTimeLeft())}`] = () => {
                    offer.complete();

                    cleverapps.toolModel.refresh();
                };
            });

            return res;
        }),

        toggleDebugClick: {
            flag: "toggleDebugClick"
        },

        bubbleStack: {
            pushUnit: () => {
                const unit = {
                    code: PseudoRandom.GET().choose(["pp", "rr", "qq"]),
                    stage: Math.round(Math.random() * 3)
                };

                Merge2.current.bubblesStack.push(unit);
            },
            clear: () => {
                const bubblesStack = Merge2.current.bubblesStack;
                bubblesStack.stack = [];
                bubblesStack.trigger("onChangeUnit");
                bubblesStack.trigger("changeUnit");
                bubblesStack.save();
            }
        }
    }
});

Merge2Generator.resetNextLuckyTool = function () {
    const game = cleverapps.Tool.game;
    const handler = game[`${ToolMenuItem.ACTIVE_ITEM}nextLucky`];
    if (handler) {
        delete game[`${ToolMenuItem.ACTIVE_ITEM}nextLucky`];
        game.nextLucky = handler;
        cleverapps.toolModel.refresh();
    }
};
